import axios from "axios";
import { getToken, getTokenMicro } from "../../../config/getToken";
import { env } from "../../../env";
import { convertFileToBase64 } from "../../../utils/functions";
import { CODES } from "../../../consts/codes";

/** Filtra las geografías.
 * @param {Object} data - Datos de filtro.
 * @returns {Promise<*>} Geografías filtradas. */
export async function ApplyFiltersGeographies(data) {
  const token = await getToken();

  return axios({
    method: "POST",
    url: "geographies",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene el listado completo de geografías.
 * @returns {Promise<*>} Listado de geografías. */
export async function GetGeographiesList() {
  const token = await getToken();
  return axios({
    method: "GET",
    url: "geographies",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Obtiene las ciudades de un país.
 * @param {string} country - Código del país.
 * @returns {Promise<*>} Listado de ciudades. */
export async function GetCitiesPerCountryList(country) {
  const token = await getToken();
  return axios({
    method: "GET",
    baseURL: env.REACT_APP_API_URL,
    url: `geographies/cities/countries/${country}`,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

//TODO: ajustar el objeto data con los nuevos atributos donde se haga el llamado a GetGeographiesLoadList, el axios ya esta ajustado
/** Obtiene el listado de cargas de geografías de una compañía.
 * @param {Object} data - Datos de consulta.
 * @returns {Promise<*>} Listado de cargas. */
export async function GetGeographiesLoadList(data) {
  const token = await getToken();
  const tokenMicro = await getTokenMicro();

  return axios({
    method: "POST",
    data: data,
    url: `masters/uploads/companies`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
      "X-Authorization": tokenMicro,
    },
  });
}

/**
 * Función que permite validar si una geografía puede ser eliminada
 * @param {data} Objeto que contiene los datos de validación para eliminar la gografía
 * @returns Confirmación exitosa o fallida de la eliminación
 */
export async function ValidateDeleteGeography(data) {
  const token = await getToken();

  return axios({
    method: "POST",
    data: data,
    url: `geographies/companies/validations`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite eliminar una geografía específica
 * @param {data} Objeto que contiene los datos para eliminar la gografía
 * @returns Confirmación exitosa o fallida de la eliminación
 */
export async function DeleteGeography(data) {
  const token = await getToken();

  return axios({
    method: "DELETE",
    url: `geographies/${data.countryCode}`,
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite la carga del archivo geografia
 * @param {data} Archivo de geografías
 * @returns Confirmación exitosa o fallida de la carga del archivo
 */
export async function UploadGeography(data) {
  const token = await getToken();

  const formData = new FormData();
  formData.append("file", data.file);

  const finalData = await convertFileToBase64(formData, CODES.GEOGRAPHY, data);

  return axios({
    method: "POST",
    url: "masters/uploads/geographies",
    data: finalData,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite descargar una geografía específica
 * @param {data} Objeto que contiene los datos para la descarga de geografias
 * @returns Archivo csv codificado con las geografias para ese pais
 */
export async function DownloadGeographyFile(data) {
  const token = await getToken();

  return axios({
    method: "POST",
    url: "geographies/downloads",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/** Descarga el log de errores de geografías.
 * @param {Object} data - Datos del log a descargar.
 * @returns {Promise<*>} Log de errores. */
export async function DownloadGeographyLogFile(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "masters/downloads/logs",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite descargar la guía de geografías
 * @returns Archivo codificado en base64
 */
export async function DownloadGeographyGuide() {
  const token = await getToken();

  return axios({
    method: "GET",
    url: "geographies/downloads/guides",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

/**
 * Función que permite descargar la plantilla de geografías
 * @returns Archivo codificado en base64
 */
export async function DownloadGeographyTemplate() {
  const token = await getToken();

  return axios({
    method: "GET",
    url: "geographies/downloads/templates",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}